import {
    Component, EventEmitter, Input, Output,
    ViewEncapsulation
} from '@angular/core';
import { ClientModel } from '../../../../shared/models/client.model';
import { CommonHttpService } from '../../../../shared/services/http.service';
import { OauthService } from '../../../../shared/services/oauth.service';
import { RequestTokenParams } from '../../../../shared/models/request-token-params.model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'account-profile-basic-data-password',
    templateUrl: './account.profile.basic-data.password.component.html',
    styleUrls: [],
    encapsulation: ViewEncapsulation.None
})
export class AccountProfileBasicDataPasswordComponent {
    @Input('client') client: ClientModel;
    @Output() done: EventEmitter<any> = new EventEmitter<any>();

    public oldPassword: string;
    public newPassword: string;
    public newPasswordConfirmation: string;

    constructor(
        protected http: CommonHttpService,
        protected oauth: OauthService,
        protected translate: TranslateService,
        protected toastr: ToastrService
    ) {}

    public save() {
        const params = new RequestTokenParams();
        params.grant_type = 'password';
        params.password = this.oldPassword;
        params.username = this.client.email;

        this.translate.get([
            'ACCOUNT.PROFILE.BOXES.BASIC_DATA.PASSWORD.UPDATE.SUCCESS',
            'ACCOUNT.PROFILE.BOXES.BASIC_DATA.PASSWORD.UPDATE.ERROR'
        ]).subscribe(translated => {
            this.oauth
                .requestToken(params)
                .subscribe(() => {
                    this.http
                        .useAuth()
                        .post(`/account/clients/${this.client.id}/passwords`, {
                            password: this.newPassword
                        })
                        .subscribe(() => {
                            this.toastr.success(translated['ACCOUNT.PROFILE.BOXES.BASIC_DATA.PASSWORD.UPDATE.SUCCESS']);
                            this.done.emit();
                        }, () => {
                            this.toastr.success(translated['ACCOUNT.PROFILE.BOXES.BASIC_DATA.PASSWORD.UPDATE.ERROR']);
                        });
                });
        });
    }

    public cancel() {
        this.done.emit();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/account/profile/basic-data/password/account.profile.basic-data.password.component.ts